import { render, staticRenderFns } from "./kpiRules.vue?vue&type=template&id=5b4c763e&"
import script from "./kpiRules.vue?vue&type=script&lang=js&"
export * from "./kpiRules.vue?vue&type=script&lang=js&"
import style0 from "./kpiRules.vue?vue&type=style&index=0&id=5b4c763e&prod&lang=scss&"
import style1 from "./kpiRules.vue?vue&type=style&index=1&id=5b4c763e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports